import { createFileRoute } from "@tanstack/react-router";
import { sitemapIndexRoute } from "@/lib/core/sitemaps";

export const Route = createFileRoute("/sitemap.xml")({
    ...sitemapIndexRoute,
});
